import React, { Component } from 'react';
import { connect } from 'react-redux';
import apiClient from '../../actions/api-client';
import { Modal, Button } from 'react-bootstrap';
import SelectFieldGroup from '../forms/select-field-group';
import TextFieldGroup from '../forms/text-field-group';
import './generateQuestionsWithAI.css';
import UploadContainer from './UploadContainer';
class GenerateQuestionsWithAI extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCustomizedSubjectPopup: false,
      showCustomizedEntryPopupForSubject: false,
      showCustomizedEntryForCategory: false,
      showCustomizedEntryForSubCategory: false,
      customSubject: "",
      customCategory: "",
      customSubCategory: "",
      customEntryForID: 0,

      customSubjects: [],
      customCategories: [{ id: "Add Custom", name: "Add Custom", isCustom: true }],
      customSubCategories: [{ id: "Add Custom", name: "Add Custom", isCustom: true }],
      allSubjects: [],
      allCategories: [],
      allSubCategories: [],
      selectedSubject: "",
      selectedCategory: "",
      selectedSubCategory: "",
      selectedSchoolType: [],
      errors: {},
      subjects: [],
      category: "",
      numberOfQuestionsMCQ: '0',
      numberOfQuestionsEssay: '0',
      AISelectedGrade: '',
      AISelectedStandard: 'NY NextGen',
      learnerPalFileUrl: '',
      learnerPalFileName: '',
      passageWordCount: '0',
    };

    this.onAddCustomChanged = this.onAddCustomChanged.bind(this);
    this.propertyChangedHandler = this.propertyChangedHandler.bind(this);
    this.getSubjectsDropdown = this.getSubjectsDropdown.bind(this);
    this.customizedSubjectPopup = this.customizedSubjectPopup.bind(this);
    this.handleAddCustom = this.handleAddCustom.bind(this);
    this.getAllSubjects = this.getAllSubjects.bind(this);
    this.updateCustomCategories = this.updateCustomCategories.bind(this);
    this.updateSubjectsList = this.updateSubjectsList.bind(this);
    this.getAllUserSubjects = this.getAllUserSubjects.bind(this);
    this.sortList = this.sortList.bind(this);
    this.handleIncludeInQuestionsChange = this.handleIncludeInQuestionsChange.bind(this);
  }

  componentDidMount() {
    this.getAllSubjects();
  }

  getAllSubjects(id) {
    let context = this;
    let schoolName = this.props.auth.user.schoolName ? this.props.auth.user.schoolName : 'trial';
    let params = {
      schoolName: schoolName,
      ownerName: this.props.auth.user.userName,
    };

    let pathTemplate = '/subjects/ownerName/{ownerName}/schoolName/{schoolName}';
    let method = 'GET';
    let additionalParams = {};
    let body = {};

    let subject = this.state.subjects && this.state.subjects[0];
    let category = this.state.category;

    apiClient.invokeApi(params, pathTemplate, method, additionalParams, body)
      .then((result) => {
        let customSubjects = result.data;

        if (id) {
          category = context.state["selectedCategory" + id];
        }

        let update = context.updateCustomCategories(customSubjects, subject, category);

        let updatedState = {
          ...context.state,
          customSubjects,
        };

        if (id) {
          updatedState["allCategories" + id] = (context.state["allCategories" + id] || []).concat(update.allCategories);
          updatedState["allSubCategories" + id] = (context.state["allSubCategories" + id] || []).concat(update.allSubCategories);
        } else {
          let allCategories = (context.state.allCategories || []).concat(update.allCategories);
          let allSubCategories = (context.state.allSubCategories || []).concat(update.allSubCategories);
          allCategories = [...new Map(allCategories.map(obj => [obj.id, obj])).values()];
          allSubCategories = [...new Map(allSubCategories.map(obj => [obj.id, obj])).values()];
          updatedState.allCategories = allCategories;
          updatedState.allSubCategories = allSubCategories;
        }

        context.setState(updatedState, function () {
          context.updateSubjectsList([]);
        });

      })
      .catch(function (error) {
        // Optionally handle errors or set error state
      });

    this.getAllUserSubjects();
  }

  updateCustomCategories(lstCustomSubjects, selectedSubject, category) {
    let categories = [];
    let allSubCategories = [];

    if (lstCustomSubjects) {
      let subject = lstCustomSubjects.find(x => x.name === selectedSubject);
      if (subject) {
        let selectedCategory = null;
        if (subject.categories) {
          subject.categories.forEach(categ => {
            if (categ.category === category)
              selectedCategory = categ;

            if (categories.find(x => x.name == categ.category)) {
              return;
            }
            categories.push({ id: categ.category, name: categ.category, state: categ.state, subCategories: categ.subCategories });
          });
        }
        if (selectedCategory) {
          selectedCategory.subCategories.forEach((subCateg) => {
            if (allSubCategories.find(x => x.name == subCateg.subCategory)) {
              return;
            }
            allSubCategories.push({ id: subCateg.subCategory, name: subCateg.subCategory, state: subCateg.state });
          });
        }
      }
    }
    return { allCategories: categories, allSubCategories };
  }

  updateSubjectsList(sortedSubjects) {
    let { subjects } = this.props.auth.user;

    if (this.state.customSubjects) {
      var lstSubjects = [];
      this.state.customSubjects.forEach(x => {
        let subjectName = x.name;
        if (!subjects.find(y => y == subjectName))
          return;
        lstSubjects.push({ "id": subjectName, "name": subjectName });
      });
      sortedSubjects = lstSubjects;
    }

    this.sortList(sortedSubjects);

    if (!this.isModify)
      sortedSubjects.splice(0, 0, { "id": "Add Custom", "name": "Add Custom", isCustom: true });

    this.setState({ allSubjects: sortedSubjects });
  }

  getAllUserSubjects() {
    let sortedSubjects = []
    this.props.auth.user.subjects.forEach(sub => {
      sortedSubjects.push({ "id": sub, "name": sub });
    });
    this.updateSubjectsList(sortedSubjects);
  }

  sortList(arr, keepCustomLast) {
    if (!Array.isArray(arr)) return;
    arr.sort(function(a, b) {
      if (a.isCustom && !b.isCustom) return 1;
      if (!a.isCustom && b.isCustom) return -1;
      return (a.name || a.id || '').localeCompare(b.name || b.id || '');
    });
    if (keepCustomLast) {
      const custom = arr.filter(x => x.isCustom);
      const rest = arr.filter(x => !x.isCustom);
      arr.length = 0;
      arr.push(...rest, ...custom);
    }
  }

  onAddCustomChanged(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

    updateSubjectsTable(customSubject, isUpdate) {
    // Find the subject in customSubjects matching selectedSubject1
        let categoryT = [];
        this.state.customSubjects.forEach(x => {
            let subjectName = x.name;
            if (subjectName === this.state.selectedSubject) {
            categoryT = [x];
            }
        });

        // If found, push the new category to that subject's categories
        if (categoryT.length > 0 && categoryT[0].categories) {
            categoryT[0].categories.push(customSubject.categories[0]);
        }

        // Build the body for the API call
        let schoolName = this.props.auth.user.schoolName ? this.props.auth.user.schoolName : "Trial";
        let body = {
            ownerName: this.props.auth.user.userName,
            schoolName: schoolName,
            subjectName: customSubject.name,
            categories: categoryT.length > 0 ? categoryT[0].categories : customSubject.categories,
        };

        // Optional fields
        if (customSubject.updatedSubject)
            body.updatedSubject = customSubject.updatedSubject;
        else if (customSubject.updatedCategory)
            body.updatedCategory = customSubject.updatedCategory;
        else if (customSubject.updatedSubCategory)
            body.updatedSubCategory = customSubject.updatedSubCategory;

        if (customSubject.subjectState)
            body.subjectState = customSubject.subjectState;
        if (customSubject.questionIds)
            body.questionIds = customSubject.questionIds;
        if (customSubject.tags)
            body.tags = customSubject.tags || [];

        // Deduplicate categories/subcategories
        if (body.categories) {
            body.categories = body.categories.reduce((pv, v) => {
            if (!v.category) {
                return pv;
            }
            let index = pv.findIndex(obj => obj.category === v.category);
            if (index >= 0) {
                const obj = pv[index];
                if (obj) {
                obj.subCategories.push(...v.subCategories);
                pv[index] = obj;
                }
            } else {
                pv.push({ ...v, subCategories: [...v.subCategories] });
            }
            return pv;
            }, []);
        }

        // POST or PUT
        let context = this;
        let method = isUpdate ? "PUT" : "POST";
        apiClient.invokeApi({}, '/subject', method, {}, body, "5")
            .then(function (result) {
                context.getAllSubjects();
                context.resetAllCustomFields();
            });
    }

    resetAllCustomFields() {
        this.setState({
            schoolType: null,
            selectedSchoolType: [],
            customSubCategory: "",
            customCategory: "",
            customSubject: ""
        });
    }
  
  updateSubjectInUserProfile(subject) {
  // Step 1: Clone the subjects array from user
    let userSubjects = Array.isArray(this.props.auth.user.subjects)
        ? [...this.props.auth.user.subjects]
        : [];

    // Step 2: Add subject if it doesn't exist
    if (!userSubjects.find(x => x === subject.name)) {
        userSubjects.push(subject.name);
    }

    // Step 3: Clean up the list
    const subjectsList = userSubjects.filter(Boolean);

    // Step 4: Prepare request
    const body = {
        userName: this.props.auth.user.userName,
        subjects: subjectsList
    };

    // Step 5: Make API call and update Redux/user
    apiClient.invokeApi({}, '/user', 'PUT', {}, body, "2")
        .then(result => {
        // Update localStorage (shallow update for demonstration)
        let updatedUser = { ...this.props.auth.user, subjects: subjectsList };
        localStorage.setItem('userObj', JSON.stringify(updatedUser));

        // Update Redux store
        const { dispatch } = this.props;
        dispatch({
            type: 'SET_CURRENT_USER', // Or import SET_CURRENT_USER from your types
            user: updatedUser
        });
        });
    }

handleAddCustom() {
    const isLPSchool = this.props.auth.user.schoolName === "LearnerPal";
    let {
        showCustomizedEntryPopupForSubject,
        showCustomizedEntryForCategory,
        showCustomizedEntryForSubCategory,
        customSubject,
        customCategory,
        customSubCategory,
        selectedSchoolType,
        customEntryForID
    } = this.state;
    customCategory = customCategory || this.state.selectedCategory
    customSubject = customSubject || this.state.selectedSubject

    let errors = {};
    let isValid = true;

    if (showCustomizedEntryPopupForSubject && !customSubject) {
        isValid = false;
        errors.customSubject = "Subject is required";
    }
    if (showCustomizedEntryPopupForSubject && isLPSchool && selectedSchoolType.length === 0) {
        isValid = false;
        errors.schoolType = "School Type is required";
    }
    if (showCustomizedEntryForCategory && !customCategory) {
        isValid = false;
        errors.customCategory = "Category is required";
    }
    if (showCustomizedEntryForSubCategory && !customSubCategory) {
        isValid = false;
        errors.customSubCategory = "Subcategory is required";
    }
    if (!isValid) {
        this.setState({ errors });
        return;
    }

    // Prepare new state objects
    let newState = { 
        errors: {},
        showCustomizedSubjectPopup: false,
        customSubject: "",
        customCategory: "",
        customSubCategory: "",
        showCustomizedEntryPopupForSubject: false,
        showCustomizedEntryForCategory: false,
        showCustomizedEntryForSubCategory: false,
    };

    // Copy existing arrays and fields
    const {
        customSubjects = [],
        allSubjects = [],
        customCategories = [],
        allCategories = [],
        customSubCategories = [],
        allSubCategories = [],
    } = this.state;

    let nextCustomSubjects = [...customSubjects];
    let nextAllSubjects = [...allSubjects];
    let nextCustomCategories = [...customCategories];
    let nextAllCategories = [...allCategories];
    let nextCustomSubCategories = [...customSubCategories];
    let nextAllSubCategories = [...allSubCategories];

    // Indexed fields
    let selectedSubjectField = `selectedSubject${customEntryForID}`;
    let selectedCategoryField = `selectedCategory${customEntryForID}`;
    let selectedSubCategoryField = `selectedSubCategory${customEntryForID}`;
    let allCategoriesField = customEntryForID === 0 ? "allCategories" : `allCategories${customEntryForID}`;
    let allSubCategoriesField = customEntryForID === 0 ? "allSubCategories" : `allSubCategories${customEntryForID}`;

    // Build indexed values for setState
    let indexedUpdates = {};

    // Track main selecteds for the main dropdowns
    let mainSelectedUpdates = {};

    // Add custom subject
    if (showCustomizedEntryPopupForSubject) {
        indexedUpdates[selectedSubjectField] = customSubject;
        nextCustomSubjects.push({ name: customSubject });
        nextAllSubjects.push({ id: customSubject, name: customSubject, isCustom: true });
        // Also update main selected
        mainSelectedUpdates.selectedSubject = customSubject;
    }

    // Add custom category
    if (showCustomizedEntryForCategory) {
        indexedUpdates[selectedCategoryField] = customCategory;
        nextCustomCategories.push({ id: customCategory, name: customCategory, isCustom: true });

        let targetCategories = (this.state[allCategoriesField] || []).slice();
        targetCategories.push({ id: customCategory, name: customCategory, isCustom: true });
        indexedUpdates[allCategoriesField] = targetCategories;
        // Also update main selected
        mainSelectedUpdates.selectedCategory = customCategory;
    }

    // Add custom subcategory
    if (showCustomizedEntryForSubCategory) {
        // Ensure customCategory is up-to-date
        let realCustomCategory = this.state[selectedCategoryField] || this.state.selectedCategory || customCategory;

        indexedUpdates[selectedCategoryField] = realCustomCategory;

        let targetSubCategories = (this.state[allSubCategoriesField] || []).slice();
        targetSubCategories.push({ id: customSubCategory, name: customSubCategory, isCustom: true });
        indexedUpdates[allSubCategoriesField] = targetSubCategories;

        nextCustomSubCategories.push({ id: customSubCategory, name: customSubCategory, isCustom: true });
        indexedUpdates[selectedSubCategoryField] = customSubCategory;
        // Also update main selected
        mainSelectedUpdates.selectedSubCategory = customSubCategory;
    }

    // Compose payload for updateSubjectInUserProfile and updateSubjectsTable
    let subCategory_ = { subCategory: customSubCategory };
    let category_ = { category: customCategory, subCategories: [subCategory_] };
    let customSubject_ = { name: customSubject, categories: [category_] };

    if (selectedSchoolType && selectedSchoolType.length > 0) {
        customSubject_.tags = selectedSchoolType;
    } else if (!isLPSchool) {
        customSubject_.tags = [];
    }

    if (
        this.props.auth.user.schoolName === "LearnerPal" &&
        this.props.auth.user.userType.toLowerCase() === "admin"
    ) {
        customSubject_.subjectState = "Pending";
        customSubject_.categories[0].state = "Pending";
        customSubject_.categories[0].subCategories[0].state = "Pending";
    }

    // Call external updates
    this.updateSubjectInUserProfile(customSubject_);
    if (
        showCustomizedEntryPopupForSubject ||
        showCustomizedEntryForCategory ||
        showCustomizedEntryForSubCategory
    ) {
        this.updateSubjectsTable(customSubject_, true);
    }

    // Final setState: arrays, indexed fields, resets, AND update main selects
    this.setState({
        ...newState,
        customSubjects: nextCustomSubjects,
        allSubjects: nextAllSubjects,
        customCategories: nextCustomCategories,
        allCategories: nextAllCategories,
        customSubCategories: nextCustomSubCategories,
        allSubCategories: nextAllSubCategories,
        ...indexedUpdates,
        ...mainSelectedUpdates, // <-- update main selected values
    });
}

  propertyChangedHandler = (e) => {
    const { name, value } = e.target;
    let update = { [name]: value };

    // Helper: Find subject by id or name
    const getCustomSubject = (subjectValue) =>
        this.state.customSubjects.find(
        (x) => x.id === subjectValue || x.name === subjectValue
        );

    // --- Subject changed ---
    if (name === "selectedSubject") {
        // Clear category/subcategory selections
        update.selectedCategory = "";
        update.selectedSubCategory = "";
        update.allCategories = [];
        update.allSubCategories = [];

        // Find and set categories for the selected subject
        let subject = getCustomSubject(value);
        if (subject && subject.categories) {
        let lstCategories = subject.categories.map((categ) => ({
            id: categ.category,
            name: categ.category,
        }));
        this.sortList(lstCategories);
        lstCategories.unshift({ id: "Add Custom", name: "Add Custom", isCustom: true });
        update.allCategories = lstCategories;
        }

        this.setState({
        ...update,
        showCustomizedEntryPopupForSubject: true,
        showCustomizedEntryForCategory: true,
        showCustomizedEntryForSubCategory: true,
        });
    }

    // --- Category changed ---
    if (name === "selectedCategory") {
        update.selectedSubCategory = "";
        update.allSubCategories = [];

        let subject = getCustomSubject(this.state.selectedSubject);
        if (subject && subject.categories) {
        let category = subject.categories.find((y) => y.category === value);
        if (category && category.subCategories) {
            let lstSubCategories = category.subCategories.map((categ) => ({
            id: categ.subCategory,
            name: categ.subCategory,
            }));
            this.sortList(lstSubCategories, true);
            lstSubCategories.unshift({ id: "Add Custom", name: "Add Custom", isCustom: true });
            update.allSubCategories = lstSubCategories;
        }
        }

        this.setState(update);
    }

    // --- "Add Custom" selected for any dropdown ---
    if (value === "Add Custom") {
        let popupState = {
        showCustomizedSubjectPopup: true,
        customEntryForID: 0,
        showCustomizedEntryPopupForSubject: name === "selectedSubject",
        showCustomizedEntryForCategory: name === "selectedCategory" || name === "selectedSubject",
        showCustomizedEntryForSubCategory: name === "selectedSubCategory" || name === "selectedCategory" || name === "selectedSubject",
        };
        // Adjust which popups are shown
        if (name === "selectedCategory") {
        popupState.showCustomizedEntryPopupForSubject = false;
        } else if (name === "selectedSubCategory") {
        popupState.showCustomizedEntryPopupForSubject = false;
        popupState.showCustomizedEntryForCategory = false;
        }
        // Don't update the value for "Add Custom" in selection
        this.setState({ ...popupState });
        return;
    }

  // --- Default: just set the value ---
    this.setState(update);
};

  customizedSubjectPopup() {
    const schoolTypes = [
      { id: "Lower School", name: "Lower School" },
      { id: "Middle School", name: "Middle School" },
      { id: "Upper School", name: "Upper School" },
      { id: "Professional Learning", name: "Professional Learning" },
    ];

    const isLPSchool = this.props.auth.user.schoolName === "LearnerPal";

    const setSchoolTypesHtml = (event) => {
      let keyword = "";
      if (event.target.selectedOptions && event.target.selectedOptions[0]) {
        keyword = event.target.selectedOptions[0].value;
      } else {
        keyword = event.nativeEvent.srcElement.value;
      }
      if (!this.state.selectedSchoolType.includes(keyword)) {
        this.setState((prevState) => ({
          selectedSchoolType: [...prevState.selectedSchoolType, keyword],
        }));
      }
    };

    const deleteTags = (item) => {
      this.setState((prevState) => ({
        selectedSchoolType: prevState.selectedSchoolType.filter(
          (type) => type !== item
        ),
      }));
    };

    const allSchoolTypesHtml =
      this.state.selectedSchoolType &&
      this.state.selectedSchoolType.length > 0
        ? this.state.selectedSchoolType.map((type) => (
            <span key={type} className="keywordTag">
              <input type="hidden" name="undefined[]" value={type} />
              {type}
              <span
                className="text-cross-icon"
                style={{ cursor: 'pointer' }}
                onClick={() => deleteTags(type)}
              >
                {" "}
                ×
              </span>
            </span>
          ))
        : null;

    return (
      <Modal
        id="dialogCustomEntry"
        show={this.state.showCustomizedSubjectPopup}
        style={{ zIndex: "10000" }}
        onHide={() => this.setState({ showCustomizedSubjectPopup: false, errors: {} })}
        aria-labelledby="contained-modal-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="delete-activity-modal">Add custom value(s)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="newone">
            {this.state.showCustomizedEntryPopupForSubject && (
              <TextFieldGroup
                error={this.state.errors.customSubject}
                field="customSubject"
                name="customSubject"
                value={this.state.customSubject}
                placeholder="Enter Subject"
                onChange={this.onAddCustomChanged}
              />
            )}
            {this.state.showCustomizedEntryForCategory && (
              <TextFieldGroup
                error={this.state.errors.customCategory}
                field="customCategory"
                name="customCategory"
                value={this.state.customCategory}
                placeholder="Enter Category"
                onChange={this.onAddCustomChanged}
              />
            )}
            {this.state.showCustomizedEntryForSubCategory && (
              <TextFieldGroup
                error={this.state.errors.customSubCategory}
                field="customSubCategory"
                name="customSubCategory"
                value={this.state.customSubCategory}
                placeholder="Enter Subcategory"
                onChange={this.onAddCustomChanged}
              />
            )}
            {this.state.showCustomizedEntryPopupForSubject && isLPSchool && (
              <div>
                <SelectFieldGroup
                  error={this.state.errors.schoolType}
                  dropDownId="schoolType"
                  placeholder="Select School Type"
                  field="schoolType"
                  options={schoolTypes}
                  selectWidth={false}
                  onChange={setSchoolTypesHtml}
                />
                {allSchoolTypesHtml}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleAddCustom} bsStyle="primary">
            Add
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  getSubjectsDropdown() {
    return (
      <div className="courseInfo" style={{ padding: "0px 0px 0px 15px", margin: "3px" }}>
        <div className="AI-subjects-selection" style={{ padding: "0px", margin: "0px", border: "0px" }}>
          <div className="subjects-dropdown-container">
            <SelectFieldGroup
              key="subjectDropDownId"
              dropDownId="subjectDropDownId"
              value={this.state.selectedSubject}
              field="selectedSubject"
              options={this.state.allSubjects}
              placeholder="Select Subject"
              onChange={this.propertyChangedHandler}
              selectWidth={false}
              isDisabled={false}
              error={this.state.errors.selectedSubject}
            />
            <SelectFieldGroup
              key="categoryInfo0"
              error={this.state.errors.selectedCategory}
              dropDownId="categoryInfo"
              value={this.state.selectedCategory}
              selectWidth={false}
              field="selectedCategory"
              options={this.state.allCategories}
              placeholder="Select Category"
              onChange={this.propertyChangedHandler}
            />
            <SelectFieldGroup
              key="subCategoryInfo0"
              error={this.state.errors.selectedSubCategory}
              dropDownId="subCategoryInfo"
              value={this.state.selectedSubCategory}
              field="selectedSubCategory"
              selectWidth={false}
              options={this.state.allSubCategories.map((subCat) => ({ id: subCat.id, name: subCat.name.replace(/\([^)]*\)/g, '')}))}
              placeholder="Select Subcategory"
              onChange={this.propertyChangedHandler}
            />
          </div>
        </div>
      </div>
    );
  }

  onFileUpload = (params) => {
    const { s3Key, url, fileName, fileType } = params;
    this.setState({ fileS3Key: s3Key, learnerPalFileUrl: url, learnerPalFileName: fileName, fileType: fileType });
  };

  getNumberOfQuestionsField() {
    return (
      <div>
        <div className="courseInfo" style={{ padding: "0px 0px 0px 15px", margin: "3px" }}>
          <label style={{ fontWeight: "600", marginRight: "10px" }}>Number of Questions (MCQ):</label>
          <TextFieldGroup
            error={this.state.errors.numberOfQuestionsMCQ}
            field="numberOfQuestionsMCQ"
            name="numberOfQuestionsMCQ"
            value={this.state.numberOfQuestionsMCQ}
            placeholder="Enter Number of MCQ Questions"
            type="number"
            min={0}
            max={50}
            selectWidth={false}
            onChange={this.onAddCustomChanged}
          />
        </div>
        <div className="courseInfo" style={{ padding: "0px 0px 0px 15px", margin: "3px" }}>
          <label style={{ fontWeight: "600", marginRight: "10px" }}>Number of Questions (Essay):</label>
          <TextFieldGroup
            error={this.state.errors.numberOfQuestionsEssay}
            field="numberOfQuestionsEssay"
            name="numberOfQuestionsEssay"
            value={this.state.numberOfQuestionsEssay}
            placeholder="Enter Number of Essay Questions"
            type="number"
            min={0}
            max={50}
            onChange={this.onAddCustomChanged}
            selectWidth={false}
          />
        </div>
      </div>
    );
  }

  getGradeSelection() {
    const AIGrades = [
      { id: "Grade 1", name: "Grade 1" },
      { id: "Grade 2", name: "Grade 2" },
      { id: "Grade 3", name: "Grade 3" },
      { id: "Grade 4", name: "Grade 4" },
      { id: "Grade 5", name: "Grade 5" },
      { id: "Grade 6", name: "Grade 6" },
      { id: "Grade 7", name: "Grade 7" },
      { id: "Grade 8", name: "Grade 8" },
      { id: "Grade 9", name: "Grade 9" },
      { id: "Grade 10", name: "Grade 10" },
      { id: "Grade 11", name: "Grade 11" },
      { id: "Grade 12", name: "Grade 12" },
    ];

    const numberOfWordsMapping = {
      "Grade 1": '350',
      "Grade 2": '350',
      "Grade 3": '575',
      "Grade 4": '675',
      "Grade 5": '775',
      "Grade 6": '775', 
      "Grade 7": '875',
      "Grade 8": '975',
      "Grade 9": '900',
      "Grade 10": '950',
      "Grade 11": '1050',
      "Grade 12": '1100',
    }
    return (
      <div
        className="courseInfo"
        style={{ padding: "0px 0px 0px 15px", margin: "3px" }}
      >
        <label style={{ fontWeight: "600", marginRight: "10px" }}>
          Grade Level:
        </label>
        <SelectFieldGroup
          dropDownId="AIGradeSelection"
          selectWidth={false}
          error={this.state.errors.AISelectedGrade}
          value={this.state.AISelectedGrade}
          field="AISelectedGrade"
          options={AIGrades}
          placeholder="Select Grade"
          onChange={(e) => this.setState({ AISelectedGrade: e.target.value, passageWordCount: numberOfWordsMapping[e.target.value] })}
        />
      </div>
    );
  }

  getPassageCreationFields() {
    return (
      <div
        style={{ padding: "0px 0px 0px 15px", display: "flex", height:'75px' }}
      >
        <div
          className="fieldBox display-center"
          key="PassageCreation"
          onClick={(e) => e.stopPropagation()} // prevent file picker
        >
          <input
            type="checkbox"
            id="generatePassage"
            className="css-checkbox"
            name="generatePassage"
            checked={this.state.createPassage}
            onChange={() => {
              const isChecked = document.getElementById('generatePassage').checked;
              this.setState({ createPassage: isChecked });
            }}
          />
          <label htmlFor="generatePassage" className="css-label1 display-center" style={{ margin: "0px" }}>
            Create Passage For Questions
          </label>
        </div>
        {false && this.state.createPassage && (
          <div className="words-count-container">
            <label>
              Number of Words in Passage:
            </label>
            <TextFieldGroup
              error={this.state.errors.passageWordCount}
              field="passageWordCount"
              name="passageWordCount"
              value={this.state.passageWordCount}
              placeholder="Enter Number of Words"
              type="number"
              min={100}
              onChange={this.onAddCustomChanged}
              selectWidth={false}
            />
          </div>
        )}
      </div>
    );
  }

  getStandardSelection() {
    const AIStandards = [
      { id: "NY NextGen", name: "NY NextGen" },
      { id: "Texas Essential Knowledge and Skills (TEKS)", name: "Texas Essential Knowledge and Skills (TEKS)" },
    ];
    return (
      <div
        className="courseInfo"
        style={{ padding: "0px 0px 0px 15px", margin: "3px" }}
      >
        <label style={{ fontWeight: "600", marginRight: "10px" }}>
          Standard:
        </label>
        <SelectFieldGroup
          dropDownId="AIStandardSelection"
          selectWidth={false}
          error={this.state.errors.AISelectedStandard}
          value={this.state.AISelectedStandard}
          field="AISelectedStandard"
          options={AIStandards}
          placeholder="Select Standard"
          onChange={(e) => this.setState({ AISelectedStandard: e.target.value })}
        />
      </div>
    );
  }
  

  createQuestionsWithAI() {
    const {
      selectedSubject,
      selectedCategory,
      selectedSubCategory,
      numberOfQuestionsMCQ,
      numberOfQuestionsEssay,
      AISelectedGrade,
      fileS3Key,
      AISelectedStandard,
      learnerPalFileUrl,
      learnerPalFileName,
      includeInQuestions,
      fileType,
      passageWordCount,
      createPassage
    } = this.state;

    let errors = {};
    let isValid = true;

    // --- Subject validation ---
    if (!selectedSubject) {
      errors.selectedSubject = "Subject is required";
      isValid = false;
    }

    // --- Category validation ---
    if (!selectedCategory) {
      errors.selectedCategory = "Category is required";
      isValid = false;
    }

    // --- Subcategory validation ---
    if (!selectedSubCategory) {
      errors.selectedSubCategory = "Subcategory is required";
      isValid = false;
    }

    // --- Grade validation ---
    if (!AISelectedGrade) {
      errors.AISelectedGrade = "Grade selection is required";
      isValid = false;
    }

    // --- Grade validation ---
    if (!AISelectedStandard) {
      errors.AISelectedStandard = "Standard selection is required";
      isValid = false;
    }

    // --- Question count validation ---
    const numMCQ = Number(numberOfQuestionsMCQ);
    const numEssay = Number(numberOfQuestionsEssay);
    if ((!numMCQ || numMCQ <= 0) && (!numEssay || numEssay <= 0)) {
      errors.numberOfQuestionsMCQ = "Enter at least one question count (MCQ or Essay)";
      errors.numberOfQuestionsEssay = "Enter at least one question count (MCQ or Essay)";
      isValid = false;
    }

    // --- Stop if invalid ---
    if (!isValid) {
      this.setState({ errors });
      return;
    }

    // --- All good: build payload ---
    const payload = {
      subject: selectedSubject,
      category: selectedCategory,
      subCategory: selectedSubCategory,
      difficulty: AISelectedGrade,
      numMCQ: numMCQ,
      numEssay: numEssay,
      s3Key: fileS3Key || "",
      ownerName: this.props.auth.user.userName,
      schoolName: this.props.auth.user.schoolName || "trial",
      educationalStandard: AISelectedStandard,
      learnerPalFileUrl: learnerPalFileUrl || "",
      learnerPalFileName: learnerPalFileName || "",
      includeInQuestions: learnerPalFileUrl && learnerPalFileUrl != "" ? true : false,
      fileType: fileType || "",
      passageWordCount: passageWordCount || 0,
      includePassage: createPassage || false
    };

    console.log("✅ Creating questions with AI payload:", payload);
    this.props.showLoader();
    apiClient.invokeApi({}, '/generateQuestionsWithAI', 'POST', {}, payload)
      .then(res => {
        console.log("Generation started:", res) 
        const jobIds = res.data.results.map(item => item.value.payload.id);
        this.props.onSubmit && this.props.onSubmit({subjects: [payload.subject], 
                                                    category: payload.category, 
                                                    subcategory: payload.subCategory, 
                                                    jobIds: jobIds,
                                                    numberOfQuestions: numMCQ + numEssay
                                                  });
        this.props.hideLoader();
      })
      .catch(err => {
        console.error("Error:", err);
        this.props.hideLoader();
      });
  }

  handleIncludeInQuestionsChange(change) {
    this.setState({ includeInQuestions: change });
  }

  render() {
    return (
      <div className='generate-questions-with-ai-container'>
        <div>
          {this.getSubjectsDropdown()}
          {this.getGradeSelection()}
          {this.getStandardSelection()}
          {this.getPassageCreationFields()}
          {this.getNumberOfQuestionsField()}
        </div>
        {this.state.showCustomizedSubjectPopup && this.customizedSubjectPopup()}
        <UploadContainer onUpload={this.onFileUpload}  error={this.state.errors.fileS3Key} onIncludeChange={this.handleIncludeInQuestionsChange} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { ...state };
}

export default connect(mapStateToProps, null, null, { withRef: true })(GenerateQuestionsWithAI);
